import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { paths } from '@shared/config';
import { campaignSearch } from '@shared/lib/campaignParams';
import { consumeReturnTo, safeReturnPath } from '@shared/lib/returnTo';

interface AfterSignInRedirectProps {
  /** query текущей страницы: при переходе на главную с неё переносятся метки кампании. */
  search: string;
}

/**
 * Переход после входа или знакомства: туда, куда гость шёл до входа (returnTo, Ф0), иначе на
 * главную с метками кампании. Адрес возврата у вернувшегося гостя уже содержит свой query.
 *
 * Адрес читается в эффекте и один раз: consumeReturnTo стирает его, а StrictMode повторяет и
 * рендер, и эффект — повторное чтение получило бы null и увело на главную.
 */
export function AfterSignInRedirect({ search }: AfterSignInRedirectProps) {
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    // Уже вошедший открыл вход с `?next=` («Войти» на демо — в миссию): туда, а не на главную (прогон тестировщика 28.10).
    const next = safeReturnPath(new URLSearchParams(search).get('next'));
    const stored = consumeReturnTo();
    navigate(next ?? stored ?? { pathname: paths.dashboard, search: campaignSearch(search) }, { replace: true });
  }, [navigate, search]);

  return null;
}
